






import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';

@Component({})
export default class Spinner extends Vue {

}
